import { createCoreMethod } from '../../utils/createCoreMethod';

export const getHeatMapLayersNames = createCoreMethod(
  'getHeatMapLayersNames',
  async () => {
    const heatmapLayers = figma.currentPage.children
      .filter((layer) => layer.name.includes('Heatmap'))
      .map((layer) => layer.name);

    return heatmapLayers;
  }
);
